import React from "react";

export default function MyBot() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">MyBot</h2>
        </div>
      </div>
    </div>
  );
}
